module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABWSURBVDiNY2AYBdQF////5/n//38yHnmJ////xyCLMWFRl/j///9+bJoZGBj2MzAw6BDjiiPIhkBtvv7///8JhHyBYQjJmrEY8p5kzWiGpJCleRQQDwBnolMMlCN0fQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down_white.png
// module id = upAy
// module chunks = 18